import { FC } from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const BrandHighlight: FC = () => {
  const navigate = useNavigate();

  const handleStartTrial = () => {
    navigate('/register');
  };

  return (
    <section className="w-full bg-gradient-to-b from-gray-50 to-white py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-16 flex justify-center">
            <img
              src="https://media.financieramente.kids/logo-financieramente.png"
              alt="FinancieraMente Logo"
              className="w-[400px] md:w-[500px] h-auto"
              loading="eager"
              decoding="async"
            />
          </div>

          {/* Título */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 pb-4 bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent leading-[1.4]">
            Revolucionando la Educación Financiera y de Negocios para Niños
          </h2>

          {/* Texto */}
          <div className="space-y-6 text-gray-600 text-lg md:text-xl mb-12">
            <p>
              Cultiva el genio financiero de tus hijos con FinancieraMente: una aventura interactiva 
              donde los niños aprenden sobre dinero, negocios y el poder de una mentalidad positiva.
            </p>
            <p>
              Nuestro programa único utiliza juegos, desafíos y lecciones prácticas diseñadas 
              para equipar a la próxima generación con las herramientas necesarias para triunfar 
              en sus futuros emprendimientos.
            </p>
            <p>
              ¡Únete a nosotros y empodera a tus hijos para que sean líderes innovadores y 
              financieramente astutos desde hoy!
            </p>
          </div>

          {/* Botón de acción */}
          <Button
            onClick={handleStartTrial}
            size="lg"
            className="bg-primary hover:bg-primary/90 text-white text-lg px-8 py-6 h-auto font-semibold shadow-xl transform transition-all duration-200 hover:scale-105 hover:shadow-2xl"
          >
            Empieza la Aventura Ahora
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};
